/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiBaseService } from '../dapi-base-service';
import { DapiHttpResponse } from '../dapi-http-response';
import { DapiRequestBuilder } from '../dapi-request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { FinnairAlternativeOfferConfirmationStatus } from '../models/finnair-alternative-offer-confirmation-status';
import { FinnairAlternativeOffers } from '../models/finnair-alternative-offers';
import { FinnairSelfReacAcknowledgeRequest } from '../models/finnair-self-reac-acknowledge-request';
import { FinnairSelfReacConfirmationRequest } from '../models/finnair-self-reac-confirmation-request';
import { FinnairSelfReacConfirmationResponse } from '../models/finnair-self-reac-confirmation-response';


/**
 * Order resources in use
 */
@Injectable({
  providedIn: 'root',
})
export class SelfReaccService extends DapiBaseService {
  constructor(
    http: HttpClient
  ) {
    super(http);
  }

  /**
   * Path part for operation disruptionAlternativeOffers
   */
  static readonly DisruptionAlternativeOffersPath = '/api/order/{orderId}/disruption-rebooking/alternatives';

  /**
   * disruptionAlternativeOffers.
   *
   * Fetch alternative offers for a disrupted Order
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `disruptionAlternativeOffers()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  disruptionAlternativeOffers$Response(rootUrl: string, params: {
    orderId: string;
    locale?: string;
    hash?: string;
    boundIndex: number;
  }): Observable<DapiHttpResponse<FinnairAlternativeOffers>> {
    const rb = new DapiRequestBuilder(rootUrl, SelfReaccService.DisruptionAlternativeOffersPath, 'get');

    if (params) {
      rb.path('orderId', params.orderId, {});
      rb.query('locale', params.locale, {});
      rb.query('hash', params.hash, {});
      rb.query('boundIndex', params.boundIndex, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as DapiHttpResponse<FinnairAlternativeOffers>;
      }),
      catchErrorAsJson()
    );
  }

  /**
   * disruptionAlternativeOffers.
   *
   * Fetch alternative offers for a disrupted Order
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `disruptionAlternativeOffers$Response()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  disruptionAlternativeOffers(rootUrl: string, params: {
    orderId: string;
    locale?: string;
    hash?: string;
    boundIndex: number;
  }): Observable<FinnairAlternativeOffers> {
    return this.disruptionAlternativeOffers$Response(rootUrl, params).pipe(
      map((r: DapiHttpResponse<FinnairAlternativeOffers>) => r.body as FinnairAlternativeOffers)
    );
  }

  /**
   * Path part for operation disruptionConfirmAcknowledge
   */
  static readonly DisruptionConfirmAcknowledgePath = '/api/order/{orderId}/disruption-rebooking/confirm-acknowledge';

  /**
   * disruptionConfirmAcknowledge.
   *
   * Confirm full acknowledge
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `disruptionConfirmAcknowledge()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  disruptionConfirmAcknowledge$Response(rootUrl: string, params: {
    orderId: string;
    locale?: string;
    hash?: string;
    body: FinnairSelfReacAcknowledgeRequest
  }): Observable<DapiHttpResponse<FinnairSelfReacConfirmationResponse>> {
    const rb = new DapiRequestBuilder(rootUrl, SelfReaccService.DisruptionConfirmAcknowledgePath, 'post');

    if (params) {
      rb.path('orderId', params.orderId, {});
      rb.query('locale', params.locale, {});
      rb.query('hash', params.hash, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as DapiHttpResponse<FinnairSelfReacConfirmationResponse>;
      }),
      catchErrorAsJson()
    );
  }

  /**
   * disruptionConfirmAcknowledge.
   *
   * Confirm full acknowledge
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `disruptionConfirmAcknowledge$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  disruptionConfirmAcknowledge(rootUrl: string, params: {
    orderId: string;
    locale?: string;
    hash?: string;
    body: FinnairSelfReacAcknowledgeRequest
  }): Observable<FinnairSelfReacConfirmationResponse> {
    return this.disruptionConfirmAcknowledge$Response(rootUrl, params).pipe(
      map((r: DapiHttpResponse<FinnairSelfReacConfirmationResponse>) => r.body as FinnairSelfReacConfirmationResponse)
    );
  }

  /**
   * Path part for operation disruptionConfirmAlternative
   */
  static readonly DisruptionConfirmAlternativePath = '/api/order/{orderId}/disruption-rebooking/confirm-alternative';

  /**
   * confirm alternative offer.
   *
   * Confirm alternative offer in self reac
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `disruptionConfirmAlternative()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  disruptionConfirmAlternative$Response(rootUrl: string, params: {
    orderId: string;
    locale?: string;
    hash?: string;
    body: FinnairSelfReacConfirmationRequest
  }): Observable<DapiHttpResponse<FinnairSelfReacConfirmationResponse>> {
    const rb = new DapiRequestBuilder(rootUrl, SelfReaccService.DisruptionConfirmAlternativePath, 'post');

    if (params) {
      rb.path('orderId', params.orderId, {});
      rb.query('locale', params.locale, {});
      rb.query('hash', params.hash, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as DapiHttpResponse<FinnairSelfReacConfirmationResponse>;
      }),
      catchErrorAsJson()
    );
  }

  /**
   * confirm alternative offer.
   *
   * Confirm alternative offer in self reac
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `disruptionConfirmAlternative$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  disruptionConfirmAlternative(rootUrl: string, params: {
    orderId: string;
    locale?: string;
    hash?: string;
    body: FinnairSelfReacConfirmationRequest
  }): Observable<FinnairSelfReacConfirmationResponse> {
    return this.disruptionConfirmAlternative$Response(rootUrl, params).pipe(
      map((r: DapiHttpResponse<FinnairSelfReacConfirmationResponse>) => r.body as FinnairSelfReacConfirmationResponse)
    );
  }

  /**
   * Path part for operation disruptionConfirmStatus
   */
  static readonly DisruptionConfirmStatusPath = '/api/order/{orderId}/disruption-rebooking/confirm-alternative/{jobId}';

  /**
   * disruptionConfirmStatus.
   *
   * Returns the status of an ongoing alternative confirm process.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `disruptionConfirmStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  disruptionConfirmStatus$Response(rootUrl: string, params: {
    orderId: string;
    jobId: string;
    locale?: string;
    hash?: string;
  }): Observable<DapiHttpResponse<FinnairAlternativeOfferConfirmationStatus>> {
    const rb = new DapiRequestBuilder(rootUrl, SelfReaccService.DisruptionConfirmStatusPath, 'get');

    if (params) {
      rb.path('orderId', params.orderId, {});
      rb.path('jobId', params.jobId, {});
      rb.query('locale', params.locale, {});
      rb.query('hash', params.hash, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as DapiHttpResponse<FinnairAlternativeOfferConfirmationStatus>;
      }),
      catchErrorAsJson()
    );
  }

  /**
   * disruptionConfirmStatus.
   *
   * Returns the status of an ongoing alternative confirm process.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `disruptionConfirmStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  disruptionConfirmStatus(rootUrl: string, params: {
    orderId: string;
    jobId: string;
    locale?: string;
    hash?: string;
  }): Observable<FinnairAlternativeOfferConfirmationStatus> {
    return this.disruptionConfirmStatus$Response(rootUrl, params).pipe(
      map((r: DapiHttpResponse<FinnairAlternativeOfferConfirmationStatus>) => r.body as FinnairAlternativeOfferConfirmationStatus)
    );
  }

}
